import { SEO_CONFIG } from "../../config/seo.config";
import whatsappIcon from "../../../assets/WhatsApp.svg.webp";

interface WhatsAppButtonProps {
  phoneNumber?: string;
  message?: string;
  className?: string;
}

/**
 * Botón flotante de WhatsApp
 * Aparece fijo en la esquina inferior derecha de la pantalla
 * Usa el número de teléfono de la configuración SEO por defecto
 */
export function WhatsAppButton({
  phoneNumber = SEO_CONFIG.contact.phoneFormatted,
  message = "Hola, me gustaría obtener más información sobre sus productos.",
  className = "",
}: WhatsAppButtonProps) {
  // Formatear número de teléfono (quitar espacios y caracteres especiales, mantener el +)
  const formattedPhone = phoneNumber.replace(/[\s\-\(\)]/g, "");

  // Crear URL de WhatsApp con mensaje predefinido
  const whatsappUrl = `https://wa.me/${formattedPhone}?text=${encodeURIComponent(message)}`;

  return (
    <div className="group fixed bottom-6 right-6 z-[70]">
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contactar por WhatsApp"
        className={`
          w-14 h-14 md:w-16 md:h-16
          rounded-full
          shadow-lg hover:shadow-xl
          flex items-center justify-center
          transition-all duration-300 ease-in-out
          transform hover:scale-110 active:scale-95
          cursor-pointer
          overflow-hidden
          ${className}
        `}
      >
        <img
          src={whatsappIcon}
          alt="WhatsApp"
          className="w-full h-full object-contain"
        />
      </a>

      {/* Tooltip en hover (solo desktop) */}
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none hidden md:block">
        Contáctanos por WhatsApp
        <span className="absolute left-full top-1/2 -translate-y-1/2 border-4 border-transparent border-l-gray-900"></span>
      </span>
    </div>
  );
}
